export default __webpack_public_path__ + "static/media/Maor-Booklet-Heb.5ee06887.pdf";